module.exports = __webpack_public_path__ + "static/media/hg_mark-one_color_tonal_on_dark.77512ce0.svg";